/** @type {DomainCampaignStats} */
const DEFAULT_STATE = {
    impressions: 0,
    ctr: '0',
    revenue: '0',
    ecpm: '0',
    clicks: '0'
};

const ACTIONS = {
    REGISTER_STATS: "REGISTER_STATS",
};


/**
 * 
 * @param {DomainCampaignStats} state 
 * @param {*} action 
 * @returns {DomainCampaignStats}
 */
export default function lineItemStatsReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case ACTIONS.REGISTER_STATS:
            return { ...state, ...action.data };
        default:
            return state;
    }
}

/**
 * 
 * @param {DomainCampaignStats} stats 
 * @returns {{type: 'REGISTER_STATS', data: DomainCampaignStats}}
 */
export function registerOrderStats(stats) {
    return {
        type: ACTIONS.REGISTER_STATS,
        data: stats || {},
    };
}
